import React from "react";

import DashAdminPage from "../Components/DashBoard/dashAdmin";
function DashAdmin() {
  return <DashAdminPage />;
}

export default DashAdmin;
